export default __webpack_public_path__ + "static/media/vintage100-4.27b9817a.jpg";